// extracted by mini-css-extract-plugin
export default {"block_item":"styles_block_item__QAJX6","title":"styles_title__RrpC3","content":"styles_content__VyDCn"};